import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiListParams, ApiListResponse } from '@core/api/api.model';
import { IRole, IRoleDetail, IRoleSaveRequest } from './role.model';

@Injectable({ providedIn: 'root' })
export class RoleApi {
  private readonly http = inject(HttpClient);

  getRoles(params: ApiListParams): Observable<ApiListResponse<IRole>> {
    return this.http.get<ApiListResponse<IRole>>(`${environment.api}rights/`, {
      params: params as Record<string, string | number | boolean>,
    });
  }

  getRole(id: number): Observable<IRoleDetail> {
    return this.http.get<IRoleDetail>(`${environment.api}rights/${id}/`);
  }

  createRole(input: IRoleSaveRequest): Observable<IRoleDetail> {
    return this.http.post<IRoleDetail>(`${environment.api}rights/`, input);
  }

  updateRole(id: number, input: IRoleSaveRequest): Observable<IRoleDetail> {
    return this.http.put<IRoleDetail>(`${environment.api}rights/${id}/`, input);
  }

  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.api}rights/${id}/`);
  }
}
